// extracted by mini-css-extract-plugin
module.exports = {"form__button":"_1829e0"};